import { HourglassBottomRounded } from '@mui/icons-material';
import { Chip, Divider, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { useMyAssortmentTranslation } from '@retail/my-assortment/i18n';
import { TrashIcon } from '@shared/custom-icons';

interface Props {
  tagName: string;
  hasEndDate?: boolean;
  /** A more compact chip, e.g. for showing selected values inside an input. */
  small?: boolean;
  onDelete?: () => void;
}

export function SubAssortmentChip({ tagName, hasEndDate, small, onDelete }: Props) {
  const { t } = useMyAssortmentTranslation();

  return (
    <Chip
      size="small"
      sx={(theme) => {
        const { sky } = theme.vars.palette.semantic.tint;
        return {
          height: small ? 20 : 24,
          maxWidth: '100%',
          bgcolor: sky.soft,
          border: `1px solid ${sky.strong}`,
          color: sky.text,
          '& .MuiChip-label': { px: small ? 0.75 : 1 },
        };
      }}
      label={
        <Stack flexDirection="row" alignItems="center" gap={0.5}>
          {hasEndDate && <HourglassBottomRounded sx={{ fontSize: 14, color: 'inherit' }} />}
          <Typography variant="body3" noWrap>
            {tagName}
          </Typography>
          {onDelete && (
            <>
              <Divider
                orientation="vertical"
                flexItem
                sx={(theme) => ({
                  my: 0.5,
                  borderColor: theme.vars.palette.semantic.tint.sky.strong,
                })}
              />
              <Tooltip title={t('myAssortment.centralAssortments.deleteFromAssortmentTag')}>
                <IconButton
                  aria-label={t('myAssortment.centralAssortments.deleteFromAssortmentTag')}
                  sx={{ p: 0, color: 'inherit', opacity: 0.7, '&:hover': { opacity: 1 } }}
                  onClick={onDelete}
                >
                  <TrashIcon sx={{ fontSize: 16 }} />
                </IconButton>
              </Tooltip>
            </>
          )}
        </Stack>
      }
    />
  );
}
